import React from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import arkIcon from '../../../theme/assets/other/tc_cab_apostol_ark_icon.png';
import infoIcon from '../../../theme/assets/svg/tc_cab_info_icon.svg';
import closeIcon from '../../../theme/assets/svg/tc_cab_apostol_close_icon.svg';

const EMISSION_PERCENT = 5;

const percentHandler = (value) => {
    if (value === null || value === undefined || value === '') return '—';
    return `${Number(value) * 1}%`;
};

const CabinetApostolTable = (props) => {
    const { isOpen, closeHandler } = props;

    const { t } = useTranslation();

    const referrals = useSelector(store => store.cabinet.referrals);
    const referralsStarted = useSelector(store => store.cabinet.referralsStarted);

    const periods = Array.isArray(referrals?.periods) ? referrals.periods : [];

    if (!isOpen) return null;

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap}`}>
                    <div
                        className={`${Styles.closeBtn}`}
                        onClick={closeHandler}
                        title={t('Закрыть')}
                    >
                        <img src={closeIcon} alt={t('Закрыть')}/>
                    </div>

                    <div className={`${Styles.cardTitle}`}>{t('Таблица вознаграждений')}</div>
                    <div className={`${Styles.cardNote}`}>
                        {t('Всего выделено')} {EMISSION_PERCENT}% {t('токенов от общей эмиссии. Они будут распределяться следующим образом:')}
                    </div>

                    <div className={`${Styles.tableWrap}`}>
                        <div className={`${Styles.tableHead}`}>
                            <div className={`${Styles.tableHeadItem}`}>{t('Ковчег')}</div>
                            <div className={`${Styles.tableHeadItem}`}>1 {t('уровень')}</div>
                            <div className={`${Styles.tableHeadItem}`}>2 {t('уровень')}</div>
                            <div className={`${Styles.tableHeadItem}`}>3 {t('уровень')}</div>
                        </div>
                        <div className={`${Styles.tableBody}`}>
                            {periods.length > 0 ? periods.map((item, index) => {
                                return (
                                    <div className={`${Styles.tableRow}`} key={'apostol-period_' + (item?.number ?? index)}>
                                        <div className={`${Styles.tableRowName}`}>
                                            <div className={`${Styles.tableRowIconWrap}`}>
                                                <img src={arkIcon} alt=""/>
                                            </div>
                                            <span>{t('Ковчег')} {item?.number}</span>
                                        </div>
                                        {[item?.level_1_percent, item?.level_2_percent, item?.level_3_percent].map((percent, levelIndex) => {
                                            return (
                                                <div className={`${Styles.tableRowValue}`} key={'apostol-period-level_' + levelIndex}>
                                                    {/* подпись видна только в узкой раскладке, где шапки таблицы нет */}
                                                    <span className={`${Styles.tableRowValueName}`}>{levelIndex + 1} {t('уровень')}</span>
                                                    <span>{percentHandler(percent)}</span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            }) : (
                                <div className={`${Styles.emptyNote}`}>
                                    {referralsStarted ? t('Загрузка...') : t('Таблица вознаграждений пока пуста')}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={`${Styles.divider}`}/>

                    <div className={`${Styles.cardFooter}`}>
                        <div className={`${Styles.cardFooterIconWrap}`}>
                            <img src={infoIcon} alt=""/>
                        </div>
                        <div className={`${Styles.cardFooterText}`}>
                            {t('Уровень 1 — прямые рефералы')} <span>|</span> {t('Уровень 2 — рефералы 2-го уровня')} <span>|</span> {t('Уровень 3 — рефералы 3-го уровня')}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetApostolTable;
